<nav class="navbar navbar-expand-lg navbar-light fixed-top">
    <!--
    <a class="navbar-brand">
        <img src="assets/logos/alarbuli.svg" type="button" width="240" alt="Company logo" [routerLink] = "['home']">
    </a>
    -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" 
        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" 
        aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
                <a i18n class="nav-link" [routerLink] = "['home']">Home</a>
            </li>
            <!--
            <li class="nav-item">
                <a i18n class="nav-link" [routerLink] = "['about_us']">About us</a>
            </li>
            <li class="nav-item">
                <a i18n class="nav-link" [routerLink] = "['products']">Products</a>
            </li>
            -->
            <li class="nav-item">
                <a i18n class="nav-link" [routerLink] = "['contact']">Contact</a>
            </li>
        </ul>
    </div>
</nav>